
import { useFormik } from "formik";
import { Accordion, AccordionDetails, AccordionSummary, Divider, FormControl, FormLabel, Grid, Typography } from "@mui/material";
import FormikControl from "../../common/FormikControl";
import { useEffect, useState, useMemo, useRef } from "react"; // Added useCallback
import { CheckGreen, DownIcon, InfoIcon } from "../../../../assets/common-svg/CommonSvg";
import SkeletonLoader from "../../../../utilites/SkeltonLoader";
import { useDispatch, useSelector } from "react-redux";
import { fetchQueryList } from "../../../slices/queryInBound";
import { getNestedValue } from "../../../../pages/appointment-details/common-pre-screen/common";
import { hasAuthority } from "../../../../utils/authorities";
import { notify } from "../../../utils/methods/notification";
import CoaQueryHistory from "../../../pages/CommonCoaQuery/CoaQueryHistory";
import FormikArrayPreScreen from "../../../../pages/appointment-details/common-pre-screen/FormikArrayPreScreen";
import { cartInitialValues, CarTManufacturingFormSchema } from "./Common";
import { createCarTForm, fetchCarTFormDetails, selectIsLoading } from "../../../slices/carTForm";
import CarTFormButtons from "./Common/carTFormButtons";
import { fetchLeukapheresisConditionsDropDown, selectLeukapheresisConditionsDropdown, selectLeukapheresisConditionsLoading } from "../../../slices/leukapheresisCondition";
import CarTComment from "./Common/carTComment";
import { selectCurrentCycle } from "../../../slices/common";
import { normalizeEmptyToNull } from "../../../../utils/utils";
import ProductInformationSheet from '../../../../bmr/pages/Manufacturer/print/ProductInformationSheet'
import { LoadingButton } from "@mui/lab";

const ManufacturingForm = ({ patientData, updateTimeLine, fetchPatientInfo, initialSteps }) => {
    const dispatch = useDispatch()
    const currentCycle = useSelector(selectCurrentCycle)
    const [disabledAll, setDisabledAll] = useState(false)
    const [formKey, setFormKey] = useState(2)
    const [checkCarTForm, setCheckCarTForm] = useState({})
    const [carTFormExpanded, setCarTFormExpanded] = useState(true)
    const [queriesFields, setQueryFields] = useState([]);
    const [selectedField, setSelectedField] = useState(null);
    const [queryData, setQueryData] = useState(null);
    const leukapheresisConditionsDropdown = useSelector(selectLeukapheresisConditionsDropdown)
    const [checkForm, setCheckForm] = useState({})
    const isLoading = useSelector(selectIsLoading)
    const isLeukapheresisLoading = useSelector(selectLeukapheresisConditionsLoading)
    const LoginData = useSelector((state) => state.loginData);
    const bmr_permissions = LoginData?.bmr_permissions || [];
    const [anchorEl, setAnchorEl] = useState(null);
    const formikRef = useRef();
    const [cartFormPrint, setCartFormPrint] = useState(false)
    const [isDraft, setIsDraft] = useState(false);

    const canShowApprovalForm = useMemo(() => {
        const manufacturingStep = initialSteps?.find(op => op.slug === "product-manufactured");
        return (manufacturingStep?.status == 5 || manufacturingStep?.status == 2 || manufacturingStep?.status == 3) &&
            hasAuthority(["manufacturing-approve"], bmr_permissions);
    }, [initialSteps, bmr_permissions]);
   const enableFields = useMemo(() => {
    // If currentCycle status is 2 → fields MUST be disabled
    if (currentCycle?.status === 2 || currentCycle?.status === 0) {
        return false;
    }
    const manufacturingStep = initialSteps?.find(
        (op) => op.slug === "product-manufactured"
    );
    // Otherwise use original enable logic
    return (
        manufacturingStep?.status === 5 &&
        hasAuthority(["manufacturing-approve"], bmr_permissions)
    );
    }, [initialSteps, bmr_permissions, currentCycle]);

    const open = Boolean(anchorEl) || false;
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const [initialValues, setInitialValues] = useState(cartInitialValues)
 const handleTerminateCase = () => {
      if(currentCycle?.status == 2 || currentCycle?.status == 0)
            setDisabledAll(true)
 }

    // Memoize fetchCarTForm with useCallback
    const fetchCarTForm = async (coaFormId) => {
        if (!coaFormId) {
            if (hasAuthority(["start-manufacturing"], bmr_permissions))
                setDisabledAll(false)
            else
                setDisabledAll(true)
            setInitialValues({ ...cartInitialValues }); // This will trigger reinitialization
            if (formikRef.current) {
                setCheckForm({})
                setQueryFields([])
                formikRef.current.resetForm({ values: { ...cartInitialValues } });
                setFormKey(prev => prev + 1);
            }
            handleTerminateCase()
            return;
        }
        try {
            const response = await dispatch(
                fetchCarTFormDetails({ product_manufacturing_id: currentCycle.product_manufacturing_id, id: coaFormId })
            ).unwrap();
            if (response?.status == 200) {
                const dataValues = response?.data
                if (dataValues?.status != 'draft' && currentCycle?.car_t_manufacturing_form_id) {
                    setDisabledAll(true)
                }else{
                    setDisabledAll(false)
                }
                handleTerminateCase()
                setQueryFields(dataValues.queries);
                setInitialValues({
                ...dataValues,
                ...dataValues?.status == 'draft' ? {additional_day: cartInitialValues?.additional_day}:{},
               ...(Object.hasOwn(dataValues, 'cell_count') && {
        cell_count: (() => {
            const cellCount = dataValues.cell_count;
            
            // If it's already an array with length, return it
            if (Array.isArray(cellCount) && cellCount.length > 0) {
                return cellCount;
            }
            
            // If it's a string, try to parse it as JSON
            if (typeof cellCount === 'string' && cellCount.trim()) {
                try {
                    const parsed = JSON.parse(cellCount);
                    // Only return if it's an array
                    return Array.isArray(parsed) ? parsed : [];
                } catch (error) {
                    console.warn('Failed to parse cell_count:', error);
                    return [];
                }
            }
            // Default fallback
            return [];
        })()
    })  });
                setCheckCarTForm(dataValues)
            }
        } catch (error) {
            console.error("Error fetching car t form details:", error);
        }
    }
    useEffect(() => {
        fetchCarTForm(currentCycle?.car_t_manufacturing_form_id)
        handleServerDropdown()
    }, [currentCycle?.car_t_manufacturing_form_id, currentCycle.product_manufacturing_id])

    const loadFormOnce = () => {
        updateTimeLine()
         fetchCarTForm(currentCycle?.car_t_manufacturing_form_id)
    }
    const handleServerDropdown = async () => {
        try {
            await dispatch(fetchLeukapheresisConditionsDropDown())
        } catch (err) {
            console.error(err);
        }
    }
    
    // // Function to handle COA form submission
    const handleSubmit = async (values) => {
            const cleanValues = Object.fromEntries(
             Object.entries(values).filter(([key]) => key !== "day" && key !== "additional_day")
          );
          const { cell_count, ...sperateValue } = normalizeEmptyToNull(cleanValues);
        const data = {
            ...sperateValue,
            feasibility_assessments_id: currentCycle?.feasibility_assessments_id,
            product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,
            patient_id: patientData?.patient_information?.id,
            ...(values?.cell_count?.length > 0 && {
                cell_count: JSON.stringify(cell_count)
            }),
            is_draft : isDraft ? 1 : 0,
            status: isDraft ? 'draft' : 'submit',
            ...currentCycle?.car_t_manufacturing_form_id ? {cart_id: currentCycle?.car_t_manufacturing_form_id}:{}
        }
        try {
            await dispatch(createCarTForm(data)).unwrap();
             if(!isDraft){
            await fetchPatientInfo()
             }
            setCarTFormExpanded(false)
            loadFormOnce()
        } catch (error) {
            console.error("Error creating car t form:", error);
            throw error;
        }
    };
    // // Function to handle getPrimaryDiagnosis
    const getPrimaryDiagnosis = async () => {
        const carTFormId = currentCycle?.car_t_manufacturing_form_id;
        const response = await dispatch(
            fetchCarTFormDetails({ product_manufacturing_id: currentCycle.product_manufacturing_id, id: carTFormId })
        ).unwrap();
        if (response?.status == 200) {
            const dataValues = response?.data

            setInitialValues({
    ...dataValues,
    ...(Object.hasOwn(dataValues, 'cell_count') && {
        cell_count: (() => {
            const cellCount = dataValues.cell_count;
            
            // If it's already an array with length, return it
            if (Array.isArray(cellCount) && cellCount.length > 0) {
                return cellCount;
            }
            
            // If it's a string, try to parse it as JSON
            if (typeof cellCount === 'string' && cellCount.trim()) {
                try {
                    const parsed = JSON.parse(cellCount);
                    // Only return if it's an array
                    return Array.isArray(parsed) ? parsed : [];
                } catch (error) {
                    console.warn('Failed to parse cell_count:', error);
                    return [];
                }
            }
            // Default fallback
            return [];
        })()
    })
});
            setCheckForm(dataValues);
            setQueryFields(dataValues.queries);
        }
    };

    // Menu handlers
    const handleQuestionClick = async (event, formProps) => {
        const { name, type, label, options } = formProps;
        const query = queriesFields?.find((op) => op.fields == name);
        if(!currentCycle?.car_t_manufacturing_form_id)
            return
        setAnchorEl(event.currentTarget);
        const res = await dispatch(fetchQueryList(query?.field_id));
        if (res?.payload?.status == 200) {
            setQueryData(res?.payload?.data);
        } else {
            setQueryData([]);
        }

        const value =
            type == "select" || type == "radio"
                ? options?.find((op) => op.value == formik.values[name])?.label
                : getNestedValue(formik.values, name);

        setSelectedField({
            ...query,
            is_file: type == "file" ? true : false,
            field_label: label,
            field_name: name,
            prescreening_id: currentCycle?.car_t_manufacturing_form_id,
            patient_id: patientData?.patient_information?.id,
            field_value: value,
            isResolve: formProps?.isResolve
        });
    };

    const handleManualFormikValidaction = async () => {
        const errors = await formik.validateForm();
        if (Object.keys(errors).length > 0) {
            formik.setErrors(errors);

            const touchedFields = Object.keys(errors).reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            formik.setTouched(touchedFields);
            const errorList = Object.keys(errors)
                .map((key, index) => `${index + 1}. ${key}`)
                .join("\n");

            notify.error(`Following mandatory field(s) required:\n${errorList}`);
            return 0;
        } else {
            return 1;
        }
    };

    const formik = useFormik({
        key:`${formKey}-forms`, // Combined key
        initialValues: initialValues,
        validateOnBlur: false,
        validationSchema: CarTManufacturingFormSchema(isDraft),
        enableReinitialize: true,
        onSubmit: handleSubmit,
    });
    useEffect(() => {
        formikRef.current = formik;
    }, [formik]);

    
    const formOptions = [
         { section: "CD3+ Selection and Activation" },
         {
            label: "Leukapheresis condition",
            type: "select",
            options: leukapheresisConditionsDropdown,
            name: "leukapheresis_condition",
            placeholder: "Enter Leukapheresis condition",
            disabled: disabledAll,
            required: true,
            isResolve: ["manufacture"],
            col: 3,
        },
        {
            label: "Total CD3+ T Cells In Leukapheresis",
            subLable: "power",
            type: "number",
            name: "cd3_t_cells_in_leukapheresis",
            placeholder: "Enter CD3+ T Cells In Leukapheresis",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: true,
            col: 3,
        },
        {
            label: "Number of  CD3+ Cells taken for manufacturing",
            subLable: "power",
            type: "number",
            name: "cd3_cells_taken_for_manufacturing",
            placeholder: "Enter CD3+ Cells taken",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: true,
            col: 3,
        },
         {
            label: "CD3+ cells after CD14 Depletion",
            subLable: "power",
            type: "number",
            name: "cd3_t_cells_after_md",
            placeholder: "CD3+ cells after CD14 Depletion",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: true,
            col: 3,
        },
        {
            label: "CD3+ T Cells Taken For Selection",
            subLable: "power",
            type: "number",
            name: "cd3_t_cells_for_selection",
            placeholder: "Enter CD3+ T Cells Taken For Selection",
            disabled: disabledAll,
           isResolve: ["manufacture"],
            required: true,
            col: 3,
        },
        {
            label: "CD3+ Cells Selection",
            subLable: "power",
            type: "number",
            name: "cd3_t_cells_after_selection",
            placeholder: "Enter CD3+ T Cells Selection",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: true,
            col: 3,
        },
        {section : 'Transduction'},
        {
            label: "Batch number of LV Used",
            type: "text",
            name: "batch_number_lv_used",
            placeholder: "Enter Batch number of LV Used",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: true,
            col: 3,
        },
        {
            label: "No of Cell Transduced",
            type: "number",
            subLable: "power",
            
            name: "no_cell_transduced",
            placeholder: "Enter No of Cell Transduced",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: true,
            col: 3,
        },
        {
            label: "MOI",
            type: "number",
            name: "moi",
            placeholder: "Enter MOI",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: true,
            col: 3,
        },
     {section : 'Cell count and TE check'},
    {
        label: "Manufacturing cell count",
        type: "number",
        name: `mfg_cell`,
        placeholder: "Enter Manufacturing cell count",
        disabled: disabledAll,
        isResolve: ["manufacture"],
        required: true,
        col:3,
    },
    {
        label: "QC cell count",
        type: "number",
        subLable: "power",
        name: `qc_cell`,
        placeholder: "Enter QC cell count",
        disabled: disabledAll,
        isResolve: ["manufacture"],
        required: true,
         col:3,
    },
    {
        label: "TE",
        type: "number",
        subLable:'%',
        name: `te_cell`,
        placeholder: "Enter TE",
        disabled: disabledAll,
        isResolve: ["manufacture"],
        required: true,
         col:3,
    },
    {section : 'Cell count'},
    {
        type: "array",
        name: "cell_count",
        required: true,
        disabled: disabledAll,
        shouldFlexDel: true,
        manualValues: true,
        initialChildrenData: { 
            mfg: "", 
            qc: "", 
            te: "",
            day:""
        },
        multipleField: false,
        isResolve: ["manufacture"],
        col:3,
        useAccordion:true,
        children: (index) => [
            { 
                type: "section", 
                label: `${formik?.values?.cell_count?.[index]?.day}`,
            },
            {
                label: "MFG. cell count",
                type: "number",
                name: `cell_count.${index}.mfg`,
                placeholder: "Enter MFG. cell count",
                disabled: disabledAll,
                isResolve: ["manufacture"],
                required: false,
                childTest:true,
                col:1,
            },
            {
                label: "QC cell count",
                type: "number",
                subLable: "power",
                name: `cell_count.${index}.qc`,
                placeholder: "Enter QC cell count",
                disabled: disabledAll,
                isResolve: ["manufacture"],
                required: false,
                childTest:true,
                col:1,
            },
            {
                label: "TE",
                type: "number",
                subLable:'%',
                name: `cell_count.${index}.te`,
                placeholder: "Enter TE",
                disabled: disabledAll,
                isResolve: ["manufacture"],
                required: false,
                childTest:true,
                col:1
            },
        ],
    },
        {
            type: "textarea",
            name: "additional_day",
            required: true,
            disabled: disabledAll,
            manualValues: true,
            flexItem:true,
            multipleField: false,
            showAddBtn: true,
            fieldAppend:'cell_count',
            initialChildrenData: { 
                day:"",
                mfg: "", 
                qc: "", 
                te: "",
            },
            col: 1,
            isResolve: ["manufacture"],
            children: () => [
                { 
                 type:"label_item",
                 label: "Add Day" 
                },
                {
                    label: "",
                    setRequired:true,
                    type: "number",
                    
                    name: `day`,
                    noQuery:true,
                    disabled: disabledAll,
                    placeholder: "example: 06",
                    manualError: true,
                    isResolve: ["manufacture"],
                    initialChildrenData: { 
                    day:"",
                    mfg: "", 
                    qc: "", 
                    te: "",
                },
                  col:2
                },
            ],
        },
        { section: "Harvest" },
        {
            label: "Total no. of T cells",
            subLable: "power",
            type: "number",
            name: "total_t_cells_harvested",
            placeholder: "Enter Total no. of T cells",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: false,
            col: 3,
        },
        {
            label: "TE At Harvest",
            type: "number",
            subLable:'%',
            name: "te_at_harvest",
            placeholder: "Enter TE At Harvest",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: false,
            col: 3,
        },
        {
            label: "No. of cells given for QC",
            type: "number",
            subLable: "power",
            name: "total_t_cells_given_to_qc",
            placeholder: "Enter No. of cells given for QC",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: false,
            col: 3,
        },
        {
            label: "No. of CAR-T Cells",
            subLable: "power",
            type: "number",
            name: "total_car_t_cells_filled",
            placeholder: "Enter No. of CAR-T Cells",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: false,
            col: 2,
        },
        {
            label: "CAR-T Dose",
            type: "number",
            subLable: "power",
            extraLabel: '/kg',
            name: "car_t_dose_per_kg",
            placeholder: "Enter CAR-T Dose per kg",
            disabled: disabledAll,
            isResolve: ["manufacture"],
            required: false,
            col: 2,
        },
        { section: "Remarks" },
        {
            label: "Remarks",
            type: "textarea",
            name: "remarks",
            placeholder: "Enter remarks",
            disabled: disabledAll,
            noQuery:true,
            required: true,
            col: 1,
        },
        ...(canShowApprovalForm ? [{
            label: "Approval Remarks",
            type: "textarea",
            name: "remarks_lead",
            placeholder: "Enter remarks",
            disabled: !enableFields,
            required: true,
            noQuery: true,
            col: 1,
        }] : [])
    ];

    return <div>
        <Accordion
            className={` w-100  !rounded-lg ${carTFormExpanded ? " pt-3" : " "}`}
            sx={{
                borderLeft: `4px solid ${!currentCycle?.car_t_manufacturing_form_id || !disabledAll ||
                    queriesFields?.filter((op) => op.resolve == 0)?.length > 0
                    ? "#FB9D2C"
                    : "#00B278"
                    }`,
            }}
            expanded={carTFormExpanded} // <-- make it controlled
            onChange={() => setCarTFormExpanded((prev) => !prev)} // <-- toggle manually
        >
            <AccordionSummary
                expandIcon={
                    <div className="d-flex gap-3 align-items-center">
                        <DownIcon />
                    </div>
                }
                aria-controls="panel1-content"
                id="panel1-header"
            >
                {isLoading || isLeukapheresisLoading ? (
                    <div>
                        <SkeletonLoader
                            rowCount={1}
                            height={30}
                            width={200}
                            isTable={false}
                        />
                        <div className="flex gap-2">
                            <SkeletonLoader
                                rowCount={2}
                                height={30}
                                width={140}
                                isTable={false}
                            />
                        </div>
                    </div>
                ) : (
     <div className="flex w-full items-center justify-between mr-2">
      {/* LEFT CONTENT */}
      <div className="flex flex-col gap-2">
                        <span className="font-bold text-[0.9rem]">CAR-T Manufacturing</span>
                        <p className="flex gap-2">
                            {!currentCycle?.car_t_manufacturing_form_id || !disabledAll ||
                                queriesFields?.filter((op) => op.resolve == 0)?.length > 0 ? (
                                <span className="flex gap-3" style={{ color: "#FB9D2C" }}>
                                    <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />
                                    {"In-Progress"}
                                </span>
                            ) : (
                                <span className="flex gap-3" style={{ color: "#00B278" }}>
                                    <CheckGreen Filled="#00B278" />
                                    {"Completed"}
                                </span>
                            )}{" "}
                            {queriesFields?.filter((op) => op.resolve == 0)?.length > 0 && (
                                <div className="flex gap-2">
                                    {" "}
                                    <div className="border-l-2 ">
                                        <Typography
                                            variant="body1"
                                            className="ml-2 rounded-3xl text-center align-self-center  text-[0.8rem] w-[1.2rem] h-[1.2rem] text-[white] bg-[#FF0000]"
                                        >
                                            {queriesFields?.filter((op) => op.resolve == 0)?.length}
                                        </Typography>
                                    </div>
                                    <span className="text-[red]">Query Raised</span>
                                </div>
                            )}
                        </p>
                       </div>
      {/* RIGHT BUTTON */}
      {currentCycle?.car_t_manufacturing_form_id && <LoadingButton
        type="button"
        size="small"
        onClick={()=> setCartFormPrint(true)}
        className="!w-[100px]"
      >
        Print
      </LoadingButton>}
                    </div>
                )}
            </AccordionSummary>
            <AccordionDetails>
                <Divider />
                {isLoading || isLeukapheresisLoading ? (
                    <SkeletonLoader rowCount={5} height={80} isTable={false} />
                ) : (
                    <div>
                        <CoaQueryHistory
                            queriesFields={queriesFields}
                            preScreenId={currentCycle?.car_t_manufacturing_form_id}
                        />
                        <form className="!mt-2" onSubmit={formik.handleSubmit}>
                              
                            <Grid container spacing={2} className="mb-3 relative" >
                                {formOptions.map((props, key) => {
                                    // Skip rendering if the field has a depend condition that's not met
                                    if (props.depend) {
                                        const dependVal = formik.values[props.depend];
                                        const dependValues = props.dependValue.includes(",")
                                            ? props.dependValue.split(",").map((v) => v.trim())
                                            : [props.dependValue];

                                        if (!dependValues.includes(`${dependVal}`)) {
                                            return null;
                                        }
                                    }

                                    if (props.section) {
                                        return (
                                            <Grid key={key} item xs={12} className="">
                                                {/* Rest of your field rendering code */}
                                                {props.section && (
                                                    <strong className="!pb-3">{props.section}</strong>
                                                )}
                                            </Grid>
                                        );
                                    }
                                    if (props.section_subpart) {
                                        return (
                                            <Grid key={key} item xs={12} className="">
                                                {/* Rest of your field rendering code */}
                                                {props.section_subpart && (
                                                    <span className="pl-3 !pb-3 text-base font-medium text-[#828282]">{props.section_subpart}</span>
                                                )}
                                            </Grid>
                                        );
                                    }
                                    
                                    return !props.manualField ? (
                                        <Grid
                                            key={key}
                                            item
                                            xs={props.col && !props.children ? 12 / props.col : 12}
                                        >
                                            {/* Rest of your field rendering code */}
                                            {props.section && (
                                                <div>
                                                    <hr className="pb-2 pt-2" />

                                                    <strong className="!pb-3">
                                                        {props.section} </strong>
                                                </div>
                                            )}
                                            <FormControl
                                                variant={props.variant ?? "standard"}
                                                fullWidth={props.fullWidth ?? true}
                                                className={`pl-3 pr-3 ${props.section ? "pt-3" : ""} ${props.className ?? ""
                                                    }`}
                                            >
                                                {/* Field labels */}
                                                {props.label && props.children && (
                                                    <FormLabel
                                                        shrink
                                                        required={props.required}
                                                        className="text-[black]"
                                                    >
                                                        {props.label}
                                                    </FormLabel>
                                                )}
                                                <Typography
                                                    variant="span"
                                                    className={`z-[1] font-semibold absolute right-5 ${formik.errors[props.name] && formik.touched[props.name]
                                                        ? 'bottom-9'   // move higher when error shows
                                                        : 'bottom-4'   // default position
                                                        } text-[0.7rem]`}
                                                >
                                                    {props.subLable === "power" ? (
                                                        <p>
                                                            x10<sup>6</sup>{props?.extraLabel ? props?.extraLabel : ' Cells'}
                                                        </p>
                                                    ) : (
                                                        <span className="text-base">{props.subLable}</span>
                                                    )}
                                                </Typography>


                                                {/* Fields */}
                                                {!props.manualValues &&
                                                    !props.isObj &&
                                                    (() => {
                                                        const value = checkForm[props.name];
                                                        const questionInfo = queriesFields?.find(
                                                            (op) =>
                                                                op.fields === props.name ||
                                                                op.fields == props.depend
                                                        );
                                                        return (
                                                            <div className="relative">
                                                                <FormikControl
                                                                    formik={formik}
                                                                    {...props}
                                                                    disabled={
                                                                        questionInfo?.resolve == 0 && hasAuthority(["manufacturing-accept", "manufacturing-approve"], bmr_permissions)
                                                                            ? false
                                                                            : !hasAuthority(["manufacturing-accept", "manufacturing-approve"], bmr_permissions)
                                                                                ? true
                                                                                : props.disabled
                                                                    }
                                                                    className="mt-2"
                                                                />
                                                                {!props.noQuery &&
                                                                    (typeof value === "number"
                                                                        ? value === 0 || value !== ""
                                                                        : value !== "") &&
                                                                    (disabledAll && currentCycle?.car_t_manufacturing_form_id && currentCycle?.status != 0 && currentCycle?.status != 2) &&
                                                                    props.type != "file" ? (
                                                                    <i
                                                                        onClick={(e) =>
                                                                            handleQuestionClick(
                                                                                e,
                                                                                props,
                                                                                questionInfo
                                                                            )
                                                                        }
                                                                        style={
                                                                            questionInfo?.resolve == 0 &&
                                                                                questionInfo.fields == props.name
                                                                                ? { color: "red" }
                                                                                : {}
                                                                        }
                                                                        className={`fas fa-question-circle circle-icon cursor-pointer z-50 absolute right-2 ${!props.label && props.type != "radio"
                                                                            ? "top-[1.2rem]"
                                                                            : props.type == "radio"
                                                                                ? "top-[2rem]"
                                                                                : "top-[.6rem]"
                                                                            }`}
                                                                        aria-hidden="true"
                                                                    />
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </div>
                                                        );
                                                    })()}
                                                {/* Children Fields */}
                                                {props.children &&
                                                    (props.isObj ? (
                                                        <div className="flex gap-3">
                                                            {props.children.map(
                                                                (subFieldProps, subFieldPropsIndex) => {
                                                                    const questionInfo = queriesFields?.find(
                                                                        (op) => op.fields === subFieldProps.name
                                                                    );
                                                                    return (
                                                                        <div
                                                                            key={subFieldPropsIndex}
                                                                            className={subFieldProps?.childTest ? 'flex-1': "w-full relative"}
                                                                        >
                                                                            <FormikControl
                                                                                formik={formik}
                                                                                {...subFieldProps}
                                                                                disabled={
                                                                                    questionInfo?.resolve == 0 ? false
                                                                                        : subFieldProps.disabled
                                                                                }
                                                                            />
                                                                            {!subFieldProps.noQuery &&
                                                                                (disabledAll && currentCycle?.car_t_manufacturing_form_id) && (
                                                                                    <i
                                                                                        onClick={(e) =>
                                                                                            handleQuestionClick(
                                                                                                e,
                                                                                                subFieldProps,
                                                                                                questionInfo
                                                                                            )
                                                                                        }
                                                                                        style={
                                                                                            questionInfo?.resolve == 0
                                                                                                ? { color: "red" }
                                                                                                : {}
                                                                                        }
                                                                                        className="fas fa-question-circle circle-icon cursor-pointer z-50 absolute top-[2.1rem] right-6"
                                                                                        aria-hidden="true"
                                                                                    ></i>
                                                                                )}

                                                                        </div>
                                                                    );
                                                                }
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <FormikArrayPreScreen
                                                            handleQuestionClick={handleQuestionClick}
                                                            props={props}
                                                            formik={formik}
                                                            buttonPermission={true}
                                                            disabledAll={disabledAll}
                                                            queriesFields={queriesFields}
                                                        />
                                                    ))}
                                            </FormControl>
                                        </Grid>
                                    ) : (
                                        <Grid
                                            key={key}
                                            item
                                            xs={12}
                                            className="flex align-items-baseline"
                                        ></Grid>
                                    );
                                })}
                            </Grid>
                            {(currentCycle?.status != 2 && currentCycle?.status != 0) && <CarTFormButtons
                                patientData={patientData}
                                formik={formik}
                                fetchCarTForms={fetchCarTForm}
                                setCarTFormExpanded={setCarTFormExpanded}
                                fetchPatientInfo={fetchPatientInfo}
                                updateTimeLine={loadFormOnce}
                                setIsDraft={setIsDraft}
                            />}
                        </form>
                        <CarTComment
                            formValues={formik.values}
                            handleMenuClose={handleMenuClose}
                            open={open}
                            anchorEl={anchorEl}
                            selectedField={selectedField}
                            queryData={queryData}
                            checkCarTForm={checkCarTForm}
                            handleManualFormikValidaction={handleManualFormikValidaction}
                            getPrimaryDiagnosis={getPrimaryDiagnosis}
                        />
                       
                       <ProductInformationSheet  open={cartFormPrint}
                        onClose={() => {
                          setCartFormPrint(false);
                        }}
                        data={checkCarTForm}
                        patientInfo={patientData}/>
                    </div>
                )}
            </AccordionDetails>
        </Accordion>
    </div >
}
export default ManufacturingForm;